module.exports = __webpack_public_path__ + "static/media/squad-armory-main.cca2f661.png";